//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  name: "personal-info",
  data() {
    return {
      edit: false,
      host: process.env.API_ROOT,
      user: new Object(),
      nameShow: false,
      sexShow: false,
      phoneShow: false,
      emailShow: false,
      sexList: {
        1: '男',
        0: '女'
      }
    }
  },
  methods: {
    onShow(){
      if(this.nameShow){
        this.$refs.nameShow.setInputValue(this.user.name)
      } else if (this.phoneShow) {
        this.$refs.phone.setInputValue(this.user.phone)
      } else if (this.emailShow) {
        this.$refs.email.setInputValue(this.user.email)
      }
    },
    basicUpdate(){
      this.$put('api/person/basicUpdate', this.user).then(val => {
        this.user = val;
      })
    },
    loadImg(e){
      const imageData = new FormData();
      imageData.append('file', e.target.files[0]);
      this.$post('api/file/change-head', imageData).then(val => {
        console.log(val);
      })
    },
    save(){
      if(this.edit){
        this.basicUpdate();
      }
    },
    onConfirmPhone(value){
      this.user['phone'] = value;
      this.phoneShow = false;
      this.edit = true;
    },
    onConfirmEmail(value){
      this.user['email'] = value;
      this.emailShow = false;
      this.edit = true;
    },
    sexShowModule(e){
      this.user['sex'] = e;
      this.sexShow = false;
      this.edit = true;
    },
    onCancel(){
      this.nameShow = false;
      this.sexShow = false;
      this.phoneShow = false;
      this.emailShow = false;
    },
    onConfirmName(value){
      this.user['name'] = value;
      this.nameShow = false;
      this.edit = true;
    },
    backLastPage(){
      if (this.$store.state.device === 'wap') {
        this.$router.go(-1);
      } else {
        document.location = "http://action:10002/?";
      }
    },
  },
  mounted() {
    this.$get('api/person/current').then(val => {
      this.user = val;
    })
  },
}



// WEBPACK FOOTER //
// ./src/page/home/personal-info.vue